tindie.ads = (function(t, $) {
	t.trackClick = function() {
		if (window.ga && ga.create) {
			ga('send', 'event', {
				eventCategory: 'Product Listing',
				eventAction: 'Clicked SF Ad',
				eventLabel: 'Q4 2018',
				transport: 'beacon'
			});
		}
		return true;
	}
	t.init = function() {}
	return t;
})(tindie.ads || {}, jQuery);